<script>
import { useAlert } from 'dashboard/composables';
import CannedResponseForm from './CannedResponseForm.vue';

export default {
  name: 'AddCanned',
  components: { CannedResponseForm },
  props: {
    responseContent: {
      type: String,
      default: '',
    },
    onClose: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      isLoading: false,
      initial: { content: this.responseContent || '' },
    };
  },
  methods: {
    addCannedResponse(form) {
      this.isLoading = true;
      this.$store
        .dispatch('createCannedResponse', {
          short_code: form.shortCode,
          content: form.content,
          category: form.category,
          blob_ids: form.attachments.map(file => file.blobSignedId),
          button_label: form.buttonLabel || null,
          button_reply_content: form.buttonReplyContent || null,
          button_blob_ids: form.buttonAttachments.map(
            file => file.blobSignedId
          ),
        })
        .then(() => {
          this.isLoading = false;
          useAlert(this.$t('CANNED_MGMT.ADD.API.SUCCESS_MESSAGE'));
          this.onClose();
        })
        .catch(error => {
          this.isLoading = false;
          const errorMessage =
            error?.message || this.$t('CANNED_MGMT.ADD.API.ERROR_MESSAGE');
          useAlert(errorMessage);
        });
    },
  },
};
</script>

<template>
  <CannedResponseForm
    mode="add"
    :initial="initial"
    :is-loading="isLoading"
    @submit="addCannedResponse"
    @cancel="onClose"
  />
</template>
